import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAlineacionBody, IAlineacionesResponse, IBodyAlineacion, ICalificacionesAlineacion, ICalificacionesBlackboard, IConfiguracionPonderacion, ICursosBlackboard, IEscuelasResponse, IGetAsignaturasResponse, IInstanciasResponse, IPeriodo, IPeriodosResponse, IReqBodySincronizarBlackboard, IResSincronizarBlackboard } from 'src/app/interfaces/integracion-blackboard';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegracionesBlackboardService {
  constructor(
    private readonly http: HttpClient,
  ) { }
  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getAsignaturas( asignatura: string, currPage?: number, pageSize?: number): Observable<IGetAsignaturasResponse> {
    const url = `${environment.endpointIntegracion}/v1/corporativo/asignaturas?search=${asignatura}&page-no=${currPage}&page-size=${pageSize}`;
    return this.http.get<IGetAsignaturasResponse>(url, { headers: this.getHeaders() });
  }

  getInstancias(): Observable<IInstanciasResponse[]> {
    const url = `${environment.endpointIntegracion}/v1/blackboard/instancia/instancias`;
    return this.http.get<IInstanciasResponse[]>(url, { headers: this.getHeaders() });
  }
  getBuscarCursoBlackboard(siglaCurso: string, instancia: string): Observable<ICursosBlackboard> {
    const url = `${environment.endpointIntegracion}/v1/blackboard/cursos/${siglaCurso}/${instancia}`;
    return this.http.get<ICursosBlackboard>(url, { headers: this.getHeaders() });
  }
  getConfiguracion(anyo: string, periodoId: string, asignaturaId: string): Observable<IConfiguracionPonderacion> {
    const url = `${environment.endpointIntegracion}/v1/ponderacion/configuracion-base?anyo=${anyo}&periodo-id=${periodoId}&asignatura-id=${asignaturaId}`;
    return this.http.get<IConfiguracionPonderacion>(url, { headers: this.getHeaders() });
  }
  getConfiguracionPonderacion(anyo: number, periodoId: number, asignaturaId: number, sedeId: number, seccionId: number): Observable<IConfiguracionPonderacion> {
    const url = `${environment.endpointIntegracion}/v1/ponderacion/configuracion-ponderacion?anyo=${anyo}&periodo-id=${periodoId}&asignatura-id=${asignaturaId}&sede-id=${sedeId}&seccion-id=${seccionId}`;
    return this.http.get<IConfiguracionPonderacion>(url, { headers: this.getHeaders() });
  }
  postCrearAlineacion(body: any): Observable<any> {
    const url = `${environment.endpointIntegracion}/v1/alineacion/crear`;
    return this.http.post<any>(url,body, { headers: this.getHeaders() });
  }
  getCalificacionesBlackboard(instanciaId: string, codigoCursoBB: string): Observable<ICalificacionesBlackboard[]> {
    const url = `${environment.endpointIntegracion}/v1/blackboard/cursos/evaluaciones/${codigoCursoBB}/${instanciaId}`;
    return this.http.get<ICalificacionesBlackboard[]>(url, { headers: this.getHeaders() });
  }

  getListaPeriodos(siglaAsignaturaPDC: string): Observable<IPeriodo[]> {
    const url = `${environment.endpointIntegracion}/v1/periodos/lista/${siglaAsignaturaPDC}`;
    return this.http.get<IPeriodo[]>(url, { headers: this.getHeaders() });
  }

  getEscuelas(instanciaId: string): Observable<IEscuelasResponse> {
    const url = `${environment.endpointIntegracion}/v1/corporativo/unidadesAcademicas?instanciaId=${instanciaId}&page-no=1&page-size=100`;
    return this.http.get<IEscuelasResponse>(url, { headers: this.getHeaders() });
  }
  getPeriodos(pageNumber: string, pageSize: string): Observable<IPeriodosResponse> {
    const url = `${environment.endpointIntegracion}/v1/corporativo/periodos?page-no=${pageNumber}&page-size=${pageSize}`;
    return this.http.get<IPeriodosResponse>(url, { headers: this.getHeaders() });
  }

  getAlineaciones(body: IBodyAlineacion ): Observable<IAlineacionesResponse> {
    const url = `${environment.endpointIntegracion}/v1/alineacion/buscar?page-no=1&page-size=1000`;
    return this.http.post<IAlineacionesResponse>(url,body, { headers: this.getHeaders() });
  }

  deshabilitarAlineacion(idAlineacion: string): Observable<any> {
    const url = `${environment.endpointIntegracion}/v1/alineacion/deshabilitar/${idAlineacion}?page-no=1&page-size=1000`;
    return this.http.post<any>(url, { headers: this.getHeaders() });
  }

  getAlineacionDocente(idAlineacion: string): Observable<any> {
    const url = `${environment.endpointIntegracion}/v1/alineacion/${idAlineacion}`;
    return this.http.get<any>(url, { headers: this.getHeaders() });
  }

  confirmarAlineacion(body: IAlineacionBody): Observable<any> {
    const url = `${environment.endpointIntegracion}/v1/alineacion/docente/confirmar`;
    return this.http.post<any>(url,body, { headers: this.getHeaders() });
  }

  crearAlineacionDocente(body: any): Observable<any> {
    const url = `${environment.endpointIntegracion}/v1/alineacion/docente/crear`
    return this.http.post<any>(url, body, {headers: this.getHeaders()});
  }

  obtenerCalificacionesAlineacion(anyo: number, periodoId: number, asignaturaId: number, sedeId: number, seccionId: number): Observable<ICalificacionesAlineacion> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/configuracionBlackboard?anyo=${anyo}&periodo-id=${periodoId}&asignatura-id=${asignaturaId}&sede-id=${sedeId}&seccion-id=${seccionId}`;
    return this.http.get<ICalificacionesAlineacion>(url, { headers: this.getHeaders() });
  }

  sincronizarBlackboard(body: IReqBodySincronizarBlackboard): Observable<IResSincronizarBlackboard> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/sincronizarBlackboard`;
    return this.http.post<IResSincronizarBlackboard>(url, body, { headers: this.getHeaders() });
  }
  editarAlineacion(alineacionSeccionId: string, body: any): Observable<any> {
    const url = `${environment.endpointIntegracion}/v1/alineacion/docente/editar/${alineacionSeccionId}`
    return this.http.post<any>(url, body, {headers: this.getHeaders()});
  }
}
